export const DSAP_AGENCIES_RESET_STATE = 'DSAP_AGENCIES_RESET_STATE';
export const DSAP_AGENCIES_CURRENT_ITEM = 'DSAP_AGENCIES_CURRENT_ITEM';

export const DSAP_AGENCIES_REQUEST_LOADING = 'DSAP_AGENCIES_REQUEST_LOADING';
export const DSAP_AGENCIES_REQUEST_SUCCESS = 'DSAP_AGENCIES_REQUEST_SUCCESS';
export const DSAP_AGENCIES_REQUEST_FAILED = 'DSAP_AGENCIES_REQUEST_FAILED';

export const DSAP_AGENCIES_CURRENT_ACTION = 'DSAP_AGENCIES_CURRENT_ACTION';
export const DSAP_AGENCIES_RESET_ACTION = 'DSAP_AGENCIES_RESET_ACTION';